import { render, staticRenderFns } from "./editHistory.vue?vue&type=template&id=df39d9fc&scoped=true"
import script from "./editHistory.vue?vue&type=script&lang=js"
export * from "./editHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df39d9fc",
  null
  
)

export default component.exports